module.exports = __webpack_public_path__ + "img/horizontal_3_6_3009.b5aac565.png";